module.exports = __webpack_public_path__ + "static/media/Zonca.26c0f476.webp";